import script from "./Tags.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tags.vue?vue&type=script&setup=true&lang=ts"

import "./Tags.vue?vue&type=style&index=0&id=10b94cf9&lang=scss"

const __exports__ = script;

export default __exports__